const $ = jQuery.noConflict();

'use strict';

const pageLoader = {
	$pageLoader: null,
	$languageLink: null,

	init: function() {
		setTimeout(() => {
			pageLoader.$pageLoader.addClass('hide');
		}, 1300);

		this.initValues();
		this.bindEvents();
	},

	initValues: function() {
		pageLoader.$pageLoader = $('.js-page-loader');
		pageLoader.$languageLink = $('.nturl');
	},

	bindEvents: function() {
		pageLoader.$languageLink.on('click', pageLoader.pageLoaderToggle);
	},

	pageLoaderToggle: function() {
		pageLoader.$pageLoader.addClass('active');
		setTimeout(() => {
			pageLoader.$pageLoader.removeClass('active');
		}, 1300);
	},
};

export default pageLoader;
